export default __webpack_public_path__ + "static/media/recycle.d6aae1a2.svg";